export const ECONSENT_LOGIN_PROMPT_CHECKED_KEY = 'econsent.loginPrompt.checked';
export const ECONSENT_LOGIN_PROMPT_ELIGIBLE_KEY =
  'econsent.loginPrompt.eligible';
export const ECONSENT_LOGIN_PROMPT_VERIFICATION_FILENAME_KEY =
  'econsent.loginPrompt.verificationFilename';
export const ECONSENT_STATUS_CHANGED_EVENT = 'econsent.statusChanged';

export interface EConsentStatusChangedDetail {
  submitted: boolean;
  userId?: number;
  advisorGroupId?: number;
}
